import { useTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { RecordIcon } from '@hugeicons-pro/core-solid-rounded'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import { ORDER_STATUS_ARRAY } from '@/common/utils/Constants/Constants'

const CommonProjectStatusStyles = {
    fontWeight: '500',
    fontSize: '0.75rem',
}

const classes = {
    text: {
        color: 'text.primary',
    },
    NotCalculated: {
        color: '#F78F1E',
        ...CommonProjectStatusStyles,
    },
    Calculated: {
        color: '#007DAB',
        ...CommonProjectStatusStyles,
    },
    Ordered: {
        color: '#00BE35',
        ...CommonProjectStatusStyles,
    },
    Invoiced: {
        color: '#1EBEF7',
        ...CommonProjectStatusStyles,
    },
    Voided: {
        color: '#C62828',
        ...CommonProjectStatusStyles,
    },
    Issued: {
        color: '#0288D1',
        ...CommonProjectStatusStyles,
    },
    Lost: {
        color: '#800080',
        ...CommonProjectStatusStyles,
    },
    Cancelled: {
        color: '#E12626',
        ...CommonProjectStatusStyles,
    },
    PendingOrderConfirmation: {
        color: '#203E96',
        ...CommonProjectStatusStyles,
    },
    Rejected: {
        color: '#130F0F',
        ...CommonProjectStatusStyles,
    },
}

const ProjectStatusIcon = ({ className, value }) => {
    const { t } = useTranslation()

    let projectStatusStyle = undefined
    let label = ''
    switch (value) {
        case ORDER_STATUS_ARRAY.NotCalculated:
            projectStatusStyle = classes.NotCalculated
            label = t('Not Calculated')
            break
        case ORDER_STATUS_ARRAY.Calculated:
            projectStatusStyle = classes.Calculated
            label = t('Calculated')
            break
        case ORDER_STATUS_ARRAY.Ordered:
            projectStatusStyle = classes.Ordered
            label = t('Ordered')
            break
        case ORDER_STATUS_ARRAY.Invoiced:
            projectStatusStyle = classes.Invoiced
            label = t('Invoiced')
            break
        case ORDER_STATUS_ARRAY.Voided:
            projectStatusStyle = classes.Voided
            label = t('Voided')
            break
        case ORDER_STATUS_ARRAY.Lost:
            projectStatusStyle = classes.Lost
            label = t('Lost')
            break
        case ORDER_STATUS_ARRAY.Cancelled:
            projectStatusStyle = classes.Cancelled
            label = t('Cancelled')
            break
        case ORDER_STATUS_ARRAY.PendingOrderConfirmation:
            projectStatusStyle = classes.PendingOrderConfirmation
            label = t('Pending Order Confirmation')
            break
        case ORDER_STATUS_ARRAY.Rejected:
            projectStatusStyle = classes.Rejected
            label = t('Rejected')
            break
        case ORDER_STATUS_ARRAY.Issued:
            projectStatusStyle = classes.Issued
            label = t('Issued')
            break
        default:
            break
    }
    return (
        <Box sx={className}>
            {value !== undefined ? (
                <Box
                    data-testid="order-status-indicator"
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                        },
                        ...(Array.isArray(projectStatusStyle) ? projectStatusStyle : [projectStatusStyle]),
                    ]}
                >
                    <HugeiconsIcon
                        icon={RecordIcon}
                        size={16}
                    />
                    <Box
                        component={Typography}
                        style={{ color: 16 }}
                        sx={[
                            {
                                px: 1,
                            },
                            classes.text,
                        ]}
                        variant="body2"
                    >
                        {label}
                    </Box>
                </Box>
            ) : null}
        </Box>
    )
}

ProjectStatusIcon.propTypes = {
    className: PropTypes.object,
    value: PropTypes.oneOf([
        ORDER_STATUS_ARRAY.NotCalculated,
        ORDER_STATUS_ARRAY.Calculated,
        ORDER_STATUS_ARRAY.Ordered,
        ORDER_STATUS_ARRAY.Invoiced,
        ORDER_STATUS_ARRAY.Voided,
        ORDER_STATUS_ARRAY.Lost,
        ORDER_STATUS_ARRAY.Cancelled,
    ]),
}

export default ProjectStatusIcon
